import { IBreadcrumb } from "../../services/breadcrumbReducer";
import Link from "next/link";
import { Container, Row } from "react-bootstrap";
import styles from "./Breadcrumbs.module.css";
import breadcrumbArrow from "./assets/breadcrumbArrow.svg";
import breadcrumbArrowBlue from "./assets/breadcrumbArrowBlue.svg";
import { urlReplace } from "../../services/urlReplace";
import { Img } from "../elements/Img";
import { useRouter } from "next/router";
import { useContext } from "react";
import LanguageContext from "../LanguageContext";
import { translations } from "./translations";

const Breadcrumbs: React.FC<{
  breadcrumbs: IBreadcrumb[];
  header?: string;
}> = ({ breadcrumbs = [], header = "" }) => {
  const { language } = useContext(LanguageContext);
  const router = useRouter();
  const breadcrumbsWithoutHome = breadcrumbs.filter(
    ({ name }) => name !== "Strona główna"
  );

  return (
    <div className={styles.floatingBelowNav}>
      <Container className={styles.breadcrumbsContainer}>
        <div>
          <div className={styles.breadcrumbWrapper}>
            <p className={styles.breadcrumbTitle}>
              {translations[language].youAreHere}{" "}
            </p>
            {breadcrumbsWithoutHome.map((breadcrumb, i) => {
              if (!breadcrumb?.name) return "";

              return breadcrumbsWithoutHome.length > i + 1 ? (
                <>
                  <Link href={urlReplace(breadcrumb.url)} passHref>
                    <a
                      key={`breadcrumb-link-${breadcrumb.name}`}
                      className={styles.breadcrumbLink}
                    >
                      {breadcrumb.name}
                    </a>
                  </Link>
                  <Img
                    src={breadcrumbArrow}
                    className={styles.breadcrumbArrow}
                  />
                </>
              ) : (
                <p
                  key={`last-breadcrumb-${breadcrumb.name}`}
                  className={styles.breadcrumbLabel}
                >
                  {breadcrumb.name}
                </p>
              );
            })}
          </div>
          <button onClick={() => router.back()} className={styles.backButton}>
            <Img src={breadcrumbArrowBlue} className={styles.backArrow} />
            {translations[language].goBack}
          </button>
        </div>
        {header && <h1>{header}</h1>}
      </Container>
    </div>
  );
};
export default Breadcrumbs;
